import React from "react";
import classNames from "classnames";


import {IconBox, IconProps, IconSize} from "./index";


import type {ButtonType} from "../Button";
import LoadingSvg from "../../../assets/icons/loading.svg?react";


import './LoadingIcon.css';


export type LoadingIconProps = IconProps & {
    className?: string;
    type: ButtonType;
    size?: IconSize;
}


export const LoadingIcon = ({type, className, size, ...props}: LoadingIconProps) => {
    return (
        <IconBox
            className={classNames({
                'LoadingIcon': true,
                [className!]: !!className,
                'LoadingIcon--primary': type === 'primary',
                'LoadingIcon--neutral': type === 'neutral',
                'LoadingIcon--danger': type === 'danger',
                'LoadingIcon--success': type === 'success',
                'LoadingIcon--accent': type === 'accent',
                'LoadingIcon--ai': type === 'ai'
            })}
            size={size}
            {...props}
        >
            <LoadingSvg/>
        </IconBox>
    );
}
